export default (obj) => {
  return obj?.fields?.file?.url
}
